import styled from 'styled-components';

const CreateReportContainer = styled.div`
  padding: ${(props): string => props.theme.spaces.lg};
  background-color: ${(props): string => props.theme.colors.offWhite};
`;

export { CreateReportContainer };
